export default "__VITE_ASSET__cb3efd2e__"